{
  "site": { "host": "rantlib.dev", "port": 8787 },
  "docs": { "host": "docs.rantlib.dev", "port": 8788 },
  "explore": { "host": "explore.rantlib.dev", "port": 8789 },
  "pack": { "host": "pack.rantlib.dev", "port": 8790 }
}
